const FilterMenusOnState = (menus, state) => {

    if (state !== undefined) {
        menus = menus.filter( b => {
            const primaryAction = b.primaryAction !== undefined && b.primaryAction !== 0;
            const workflow = ! b.workflow || (b.workflow && b.entryStates.split(",").map((item)=>item.trim()).includes(state.toString()))
            return primaryAction && workflow;
        });
    }

    return menus;
}

export default FilterMenusOnState;